import React, { useCallback, useContext } from "react";

import { Site } from "../../../../../dtos/site";
import { RequestState } from "../../../../../enums/requestState";
import SignalRContext from "../../../../../signalr/context";
import { ButtonWithConfirm } from "../../../../ButtonWithConfirm";
import { useApi } from "../../../../useApi";

import { actionButtonStyle } from "./actionButtonStyle";
import { useRestartAction } from "./useRestartAction";

const buttonLabels: { [key in RequestState]: string; } = {
    [RequestState.Idle]: "Restart",
    [RequestState.Requesting]: "Requesting...",
    [RequestState.Processing]: "Restarting service...",
}

interface Props {
    site: Site;
}

export function ServiceRestartButton({ site }: Props) {
    const { siteApi } = useApi();
    const { serviceRestartTriggered } = useContext(SignalRContext);

    const request = useCallback(() => siteApi.restartService(site.id), [siteApi, site.id]);

    const { requestState, trigger } = useRestartAction({
        siteId: site.id,
        request,
        ack: serviceRestartTriggered,
        requestErrorMessage: "ERROR: Failed to request service restart",
        // The ack fires before the process stops, so this is "in progress", not "restarted".
        successMessage: "Service restart is in progress",
        failureMessage: "ERROR: Failed to restart the service",
    });

    return (
        <ButtonWithConfirm
            confirmDialogContent="Are you sure you want to restart the service?"
            confirmedCallback={trigger}
            disabled={requestState !== RequestState.Idle}
            style={actionButtonStyle}
        >
            {buttonLabels[requestState]}
        </ButtonWithConfirm>
    );
}
